import routes from "./routes";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
});

router.onError((error, to) =>
{
  if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed"))
  {
    window.location = to.fullPath
  }
})

router.beforeEach((to, from, next) =>
{
  if (!to.meta.middleware)
  {
    return next();
  }

  const middleware = Array.isArray(to.meta.middleware)
    ? to.meta.middleware
    : [to.meta.middleware];

  const context = {
    to,
    from,
    next,
    router,
  };

  // Iterate over each middleware and call them sequentially
  return middleware.reduce(
    (acc, mdw, index) => () => mdw({ ...context, next: acc }),
    next
  )();
});

export default router;
